import { MEETING_ROOM_SOLICITATIONS_PAGE_SIZE } from './reservationConstants'
import { ReservationMeetingRoomListRequestPayload } from './types'

export const buildReservationMeetingRoomListPayload = (params: {
  searchTerm?: string
  sort?: string
  page?: number
  limit?: number
  meetingRoomId?: string
}): ReservationMeetingRoomListRequestPayload => {
  const filterBy: ReservationMeetingRoomListRequestPayload['filterBy'] = []

  if (params.meetingRoomId) {
    filterBy.push({
      field: 'meeting_room_id',
      condition: params.meetingRoomId,
      comparison: 'eq',
    })
  }

  return {
    filterBy,
    sort: params.sort ?? '',
    limit: params.limit ?? MEETING_ROOM_SOLICITATIONS_PAGE_SIZE,
    page: params.page ?? 1,
    totalRows: 0,
    match: params.searchTerm?.trim() ?? '',
  }
}
